module.exports = __webpack_public_path__ + "static/ogrod-wypoczynek-31adeeb183dc9f767d9bcb0f8d7cb7a1.jpg";